import createIcon from "components/elements/Icons/create-icon";

export default createIcon(
  "XmarkSolid",
  [
    [
      "path",
      {
        d: "M16.06 7.05c0.59-0.59 0.59-1.53 0-2.12s-1.53-0.59-2.12 0L9 9.88 4.06 4.94c-0.59-0.59-1.53-0.59-2.12 0s-0.59 1.53 0 2.12L6.88 12 1.94 16.94c-0.59 0.59-0.59 1.53 0 2.12s1.53 0.59 2.12 0L9 14.12l4.94 4.94c0.59 0.59 1.53 0.59 2.12 0s0.59-1.53 0-2.12L11.12 12l4.94-4.95z",
      },
    ],
  ],
  "currentColor"
);
